import { GetMyProductivityInfo } from 'domain/usecases/doctor/get-my-productivity-info'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteGetMyProductivityInfo implements GetMyProductivityInfo {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  getMyProductivityInfo(
    params: GetMyProductivityInfo.Params
  ): Promise<GetMyProductivityInfo.Model> {
    return this.doctorRepository.getMyProductivityInfo(params)
  }
}
